const validateExceptionFields = (
    instanceDate,
    endDate
) => {
    
    const validation = {
        valid: true,
        message: '',
    }

    if (endDate === '' || endDate === undefined || endDate === null) {
        validation.valid = false
        validation.message = 'Please select a date through which the exception should apply'
        return validation
    }

    endDate = new Date(endDate)
    instanceDate = new Date(instanceDate)

    if (endDate.getTime() < instanceDate.getTime()) {
        validation.valid = false
        validation.message = 'The end date cannot be in the past'
        return validation
    }
    
    return {
        valid: true,
        message: '',
    }
}

export default validateExceptionFields